import MigratingEventsSnippet from "../../../../contents/docs/migrate/snippets/migrating-events";
import * as React from 'react';
export default {
  MigratingEventsSnippet,
  React
};